// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"d74763c4","232":"a5743bc9","320":"1d8bf36a","348":"3e8ac7d8","453":"aca09e85","696":"3a1d57c4","744":"30d4bc49","752":"9de19f66","808":"56690a0b"}[chunkId] + ".chunk.js";
};